import React, { useEffect, useState } from 'react'
import axiosInstance from '../../../../Services/axiosCommon';
import { useFormik } from 'formik';
import { useToast } from '../../../../Components/Others/ToastServices';
import { TextMediumXS } from '../../../../Components/Text/MediumText';
import { NuInputSetting } from '../../../../Components/Utils/Input';
import FormikSelectTwo, { FormikSelectTwoSett } from '../../../../Components/Utils/Select';
import MultiSelect, { MultiSelectSet } from '../../../../Components/Utils/MultiSelect';
import UseDropDown from '../../../../Components/Hooks/useDropDown';
import { CreateButton, SaveButton } from '../../../../Components/Utils/Buttons';

function InspectorSetting() {
    const { data: user } = UseDropDown(`/user/drop-down`);
    const [data, setData] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const toast = useToast();
  
    const formik = useFormik({
      initialValues: {
        users: []
      },
      onSubmit: async (values, { resetForm }) => {
        try {
          setLoading(true);
          const response = await axiosInstance.post(`/inspectors/`, { 
            users: selectedUsers.map(user => user.value) 
          });
          
          if (response.data) {
            toast.open({
              type: "success",
              message: "Inspectors added successfully",
            });
            resetForm();
            setSelectedUsers([]);
            GetData();
          }
        } catch (error) {
          toast.open({
            type: "error",
            message: "Failed to add inspectors",
          });
        } finally {
          setLoading(false);
        }
      },
    });
  
    const GetData = async () => {
      try {
        setLoading(true);
        const response = await axiosInstance.get(`/inspectors/`);
        setData(response.data?.data || []);
      } catch (error) {
        toast.open({
          type: 'error',
          message: 'Failed to fetch inspectors',
        });
      } finally {
        setLoading(false);
      }
    }
  
    const handleDelete = async (id) => {
      try {
        setLoading(true);
        const response = await axiosInstance.delete(`/inspectors/${id}`);
        if (response.status === 200) {
          toast.open({
            type: "success",
            message: "Inspector deleted successfully",
          });
          GetData();
        }
      } catch (error) {
        toast.open({
          type: "error",
          message: "Failed to delete inspector",
        });
      } finally {
        setLoading(false);
      }
    }
  
    const handleUserSelect = (selectedOptions) => {
      setSelectedUsers(selectedOptions);
    }
  
    useEffect(() => {
      GetData();
    }, []);
  
    return (
      <div className='w-full'>
        <div className="ml-4">
          <p className="w-full py-2 text-left text-sm font-semibold">
            Inspectors
          </p>
        </div>
  
        <form onSubmit={formik.handleSubmit}>
          <div className="w-full text-xs flex">
            <div className="mb-1 w-[90%]">
              <MultiSelectSet
                type="text"
                Options={user}
                placeholder="Choose inspectors"
                value={selectedUsers}
                onChange={handleUserSelect}
                isMulti={true}
                formik={formik}
                name="users"
              />
            </div>
            <div className='w-[10%] mt-4'>
              <button
                type="submit"
                className="bg-baseColor-primary text-white rounded-md px-3 py-2 hover:bg-green-800 transition-colors focus:outline-none"
                disabled={loading || selectedUsers.length === 0}
              >
                {loading ? 'Adding...' : '+'}
              </button>
            </div>
          </div>
        </form>
  
        <div className="px-3">
          <div className="w-full rounded-lg h-48 bg-[#f5f3ff] border border-gray-300 overflow-x-hidden overflow-y-auto">
            {data.length === 0 ? (
              <div className="flex items-center justify-center h-full text-gray-500">
                No inspectors added yet
              </div>
            ) : (
              <ul>
                {data.map((inspector, idx) => (
                  <li
                    className="m-1 flex justify-between items-center text-xs bg-white border border-gray-300 rounded text-main-title py-2 px-2 hover:bg-[#B3EBD7] hover:bg-opacity-50"
                    key={inspector.id || idx}
                  >
                    <TextMediumXS 
                      color="text-[#697565]" 
                      content={inspector.userName || "No name"} 
                    />
                    {!inspector?.isDefault && (
                      <span
                        onClick={() => handleDelete(inspector.id)}
                        className="text-blue-900 cursor-pointer hover:text-red-600"
                      >
                        ×
                      </span>
                    )}
                  </li>
                ))}
              </ul>
            )}
          </div>
        </div>
  
        <div className='mt-4'>
          <SaveButton 
            handleClick={GetData} 
            svg={false} 
            disabled={loading}
            text={loading ? "Refreshing..." : "Refresh List"}
          />
        </div>
      </div>
    )
}
export default InspectorSetting